import { format, parseISO } from "date-fns";
import { CalendarCheckIcon } from "@/components/common/icons";
import { DATE_FORMATS } from "@/config";
import { GREY } from "@/config/mui/colorPalette";
import AppointmentUpdateStatusRow, {
  Appointment,
} from "./appointmentUpdateStatusRow";

type Props = {
  appointment: Appointment;
  isConfirmingAppointment: boolean;
  confirmAppointmentAction: (appointmentAccessToken: string) => void;
  isAppointmentSpecific: boolean;
};

export default function AppointmentConfirmRow({
  appointment,
  isConfirmingAppointment,
  confirmAppointmentAction,
  isAppointmentSpecific,
}: Props) {
  const label = isAppointmentSpecific
    ? "Confirm appointment"
    : `Confirm ${format(
        parseISO(appointment.startTime),
        DATE_FORMATS.DATE_PICKER
      )} appointment`;

  return (
    <AppointmentUpdateStatusRow
      appointment={appointment}
      isUpdating={isConfirmingAppointment}
      updateAction={confirmAppointmentAction}
      icon={<CalendarCheckIcon color={GREY[40]} />}
      label={label}
      buttonText="Confirm"
    />
  );
}
